export default "__VITE_ASSET__DeR48_Bf__"